import { Dropdown, MenuProps, Typography } from "antd";
import React, { useState } from "react";
import { orderStatusEnums } from "../../../helpers/enums";
import ViewRxLabelModal from "../../../modals/ViewRxLabelModal";
import PrintIcon from "./../../../graphics/svgs/printIcon.svg";
import { axiosPost } from "../../../api/Axios";

const PrintDropDown: React.FC<IPrintDropDown> = ({ order }) => {
  const [showPrint, setShowPrint] = useState<boolean>(false);
  const orderOptions: MenuProps["items"] = [
    {
      key: "PRINT_SHIPPING",
      label: (
        <Typography className="general-label-class">Print Shipping</Typography>
      ),
    },
    {
      key: "PRINT_RX",
      label: <Typography className="general-label-class">Print Rx</Typography>,
    },
  ];
  const handleOpenPdf = (pdfUrl: string) => {
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.target = "_blank"; // Opens in a new tab
    link.rel = "noopener noreferrer";
    link.click();
  };
  const handleMenuClick = async (e: any) => {
    switch (e.key) {
      case "PRINT_SHIPPING":
        if (
          order.processingDetails.orderStatus ===
            orderStatusEnums.ASSIGNED_RX &&
          order.processingDetails.shippingLabel !== null
        ) {
          handleOpenPdf(order.processingDetails.shippingLabel);
        }
        break;
      case "PRINT_RX":
        try {
          setShowPrint(true);
          await axiosPost<{ orderId: string }, any>(
            "/admin/orders/updateOrderStatusToAssignedRx",
            { orderId: order._id }
          );
        } catch (error) {
          console.error("Error updating order status:", error);
        }
        break;
    }
  };
  return (
    <>
      {showPrint === true && (
        <ViewRxLabelModal
          show={showPrint}
          handleClose={(e) => setShowPrint(false)}
          order={order}
        />
      )}
      <Dropdown
        menu={{
          items: orderOptions,
          onClick: handleMenuClick,
        }}
        placement="bottomRight"
      >
        <img src={PrintIcon} style={{ width: "25px", cursor: "pointer" }} />
      </Dropdown>
    </>
  );
};

export default PrintDropDown;
